module.exports = __webpack_public_path__ + "img/常崇斌.8dd8703b.jpg";